import { render, staticRenderFns } from "./AuthStatus.vue?vue&type=template&id=118b0049&scoped=true&"
import script from "./AuthStatus.vue?vue&type=script&lang=js&"
export * from "./AuthStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118b0049",
  null
  
)

export default component.exports